export default {

      ORDER_TYPES_NAMES: [
        "Новый заказ",
        "Букет готов",
        "Доставляется",
        "Отменен",
        "Выполнен",
      ],
      
      ORDER_PAYMENTS_TYPES_NAMES: [
        "Онлайн",
        "Наличные/Карта", 
      ],
      ORDER_DELIVERY_TYPES_NAMES: [
        "Доставка",
        "Самовывоз", 
      ],
      ORDER_IS_PAY: [
        "Ожидает",
        "Оплачен", 
      ],


      ORDER_STATUS_NEW: 0,
      ORDER_STATUS_WAIT: 1,
      ORDER_STATUS_SEND: 2,
      ORDER_STATUS_CONTROL: 3,
      ORDER_STATUS_RAIT: 4,
      ORDER_STATUS_DONE: 5,

      ORDER_TYPES_COLORS: [
        "orange", "green",  "cyan",   "red", "sky", "gray", 
      ],

      UPDATE_INFO_NEW_STATUS: 'new_status',
      UPDATE_INFO_CHANGE_INFO: 'change_info',
      UPDATE_INFO_CHANGE_PRICE: 'change_price',
      UPDATE_INFO_NEW_WORKER: 'new_worker',
  };